/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type BuySharedItemTrackingProvider_buyPage$ref = any;
type SharedItemTile_item$ref = any;
export type BuySharedResultContainer_buyPage$ref = any;
export type BuySharedResultContainer_buyPage = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly " $fragmentRefs": SharedItemTile_item$ref;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": BuySharedItemTrackingProvider_buyPage$ref;
    readonly " $refType": BuySharedResultContainer_buyPage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedResultContainer_buyPage",
    "type": "BuyPageConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "BuyPageEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "SharedItemTile_item",
                            "args": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "BuySharedItemTrackingProvider_buyPage",
            "args": null
        }
    ]
} as any);
(node as any).hash = '9aaf7fb7d96e1c40812f24e6b0396bad';
export default node;
